import React, {useState} from 'react'
import Menu from '../../components/Menu/Menu'
import './MySchedule.scss'

function MySchedule() {
  const [selectedFileName, setSelectedFileName] = useState('');

  // 处理文件选择事件
  const handleFileSelect = (event) => {
    event.preventDefault();
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setSelectedFileName(`已选择文件: ${selectedFile.name}`);
    } else {
      setSelectedFileName('');
    }
  };
  
  return (
    <div className='mysch'>
      <div className='myche-header container mt-5 d-flex justify-content-between'>
        <Menu/>
        <div className='d-flex align-items-center mysch-title'>MY SCHEDULE</div>
      </div>
      <div className='myche-body d-flex justify-content-center align-items-center w-100'>
        <div>
          {/* 隐藏的文件上传输入 */}
          <input
            type="file"
            id="fileInput"
            accept=".pdf,.doc,.docx"
            style={{ display: 'none' }}
            onChange={handleFileSelect}
          />
          {/* 自定义的上传按钮 */}
          <label htmlFor="fileInput" className="myche-upload d-flex justify-content-center align-items-center">
          Upload My Schedule
          </label>
          {/* 用于显示所选文件的名称 */}
          <div id="selectedFileName">
            {selectedFileName}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MySchedule